export default class Review {
    visible = false;
}

document.addEventListener('alpine:init', () => {
    Alpine.data('review', () => new Review());
});